import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppFloat = () => (
  <div style={{ position: 'fixed', bottom: 28, right: 28, zIndex: 999, display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 10 }} className="wa-float-group">
    <div className="wa-tooltip" style={{ background: '#0a1628', color: '#fff', fontSize: 12, fontWeight: 600, padding: '8px 14px', borderRadius: 8, whiteSpace: 'nowrap', opacity: 0, transform: 'translateX(8px)', transition: 'all .2s', pointerEvents: 'none' }}>
      Chat with us on WhatsApp
    </div>
    <a
      href="https://wa.me/919542643011?text=Hi%20DigiHR%2C%20I%27d%20like%20to%20book%20a%20demo"
      target="_blank"
      rel="noopener noreferrer"
      title="Chat on WhatsApp"
      className="wa-btn"
      style={{ width: 58, height: 58, borderRadius: '50%', background: '#25D366', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 20px rgba(37,211,102,.45)', textDecoration: 'none', color: '#fff', animation: 'waPulse 2.5s infinite' }}
    >
      <MessageCircle size={26} strokeWidth={1.75} />
    </a>
    <style>{`
      .wa-btn { transition: transform .2s, box-shadow .2s; }
      .wa-btn:hover { transform: scale(1.1); box-shadow: 0 8px 32px rgba(37,211,102,.55); }
      .wa-float-group:hover .wa-tooltip { opacity: 1; transform: translateX(0); }
      @keyframes waPulse {
        0%,100% { box-shadow: 0 4px 20px rgba(37,211,102,.45); }
        50% { box-shadow: 0 4px 32px rgba(37,211,102,.7), 0 0 0 8px rgba(37,211,102,.1); }
      }
    `}</style>
  </div>
);

export default WhatsAppFloat;
